import { useSearchStoreContext } from "PFApp/search/search_context";
import { Inline } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

import css from "../search_page.module.scss";
import { activitiesTab, matchesTab, profilesTab } from "../tabs_constants";

type TitleProps = {
  tab?: string;
  count?: number;
};

const Title = ({ tab, count }: TitleProps) => {
  const { t } = useTranslation("search");
  if (count === undefined || count === null) {
    return "";
  }

  return (
    <Inline alignItems="center">
      <span>
        {tab === activitiesTab ? t("countActivitiesFound", { count }) : t("countProfilesFound", { count })}
      </span>
      <TooltipIcon content={t("resultsDependOnPerms")} />
    </Inline>
  );
};

const getResultsCount = (tab: string, matchesTotal?: number, profilesTotal?: number) =>
  ({
    [matchesTab]: matchesTotal,
    [profilesTab]: profilesTotal
  })[tab];

export const SearchPageTitle = () => {
  const {
    search: { tab, matchesMeta, profilesMeta }
  } = useSearchStoreContext();

  return (
    <div className={css.header}>
      <h1>
        <Title tab={tab} count={getResultsCount(tab, matchesMeta?.total, profilesMeta?.total)} />
      </h1>
    </div>
  );
};
